export default "__VITE_ASSET__DMMt1MNi__"